module.exports = __webpack_public_path__ + "media/images/accepted_order_icon-3fe7dbc8b999466424f685a86a84888d.webp";